import { render } from "./BlackListFilters.vue?vue&type=template&id=dc1f2f2c&scoped=true"
import script from "./BlackListFilters.vue?vue&type=script&lang=js"
export * from "./BlackListFilters.vue?vue&type=script&lang=js"

import "./BlackListFilters.vue?vue&type=style&index=0&id=dc1f2f2c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1f2f2c"]])

export default __exports__